import { render, staticRenderFns } from "./StudentApplication.vue?vue&type=template&id=587e7bae"
import script from "./StudentApplication.vue?vue&type=script&lang=js"
export * from "./StudentApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports